<template>
  <div>
    <base-header class="pb-8 pt-4"/>
    <div class="container-fluid mt--7">
      <b-card class="mb-4" no-body>
        <b-card-header>
          <div class="align-items-center row">
            <div class="col-sm-12 col-md-6">
              <h3 class="mb-0">{{ $t("Tüm Çalışanlar") }}</h3>
            </div>
            <div class="col-sm-12 col-md-6 d-none d-md-block text-right">
              <b-button variant="success" :to="{ name: 'create-employee' }">+ {{ $t("Çalışan Oluştur") }}</b-button>
            </div>
          </div>
        </b-card-header>
        <b-table ref="table" :items="getItems" :fields="fields" responsive>
          <template v-slot:cell(salary)>
            ****
          </template>
          <template v-slot:cell(full_name)="data">
            {{ data.item.full_name }} <span class="badge badge-danger" v-if="data.item.is_permit">{{ $t("İzinde") }}</span>
          </template>
          <template v-slot:cell(actions)="data">
            <b-button class="btn-outline-primary" @click="openPayPermitModal(data.item, data.item.remeaning_payment)"
                      size="sm">İzin Ver
            </b-button>
            <b-button class="btn-outline-darker" @click="openPermitHistoryModal(data.item)" size="sm">{{ $t("İzin Geçmişi") }}
            </b-button>
            <b-button variant="primary" @click="openPayAdvanceModal(data.item.id, data.item.remeaning_payment)"
                      size="sm">{{ $t("Maaşı Öde") }}
            </b-button>
            <b-button variant="warning" @click="openPayAdvanceModal(data.item.id, 0)" size="sm">{{ $t("Avans Öde") }}</b-button>
            <b-button variant="secondary" @click="openAdvanceHistoryModal(data.item)"
                      :disabled="data.item.advanceLoading" size="sm">Avans Geçmişi
            </b-button>
            <b-button variant="info" :to="{ name: 'edit-employee', params: { id: data.item.id } }" size="sm">{{ $t("Güncelle") }}
            </b-button>
            <b-button variant="danger" @click="deleteRecord(data.item.id)" size="sm">{{ $t("Sil") }}</b-button>
          </template>

        </b-table>
      </b-card>
    </div>

    <b-modal title="Avans Öde" ref="advanceModal">
      <b-form-group>
        <label>{{ $t("Ücret") }}</label>
        <b-form-input v-model="advance.price" type="number"/>
      </b-form-group>
      <b-form-group>
        <label>{{ $t("Tarih") }}</label>
        <b-form-input v-model="advance.date" type="date"/>
      </b-form-group>
      <template v-slot:modal-footer>
        <b-button variant="secondary" @click="$refs.advanceModal.hide()">{{ $t("Kapat") }}</b-button>
        <b-button variant="primary" @click="payAction">{{ $t("Ödeme Yap") }}</b-button>
      </template>
    </b-modal>

    <b-modal :title="activeEmployee.full_name+' İzin Ver'" ref="permitModal">
      <h3>{{ activeEmployee.full_name }}</h3>
      <b-form-group>
        <label>Tarih</label>
        <b-form-input v-model="permit.start_at" type="date"/>
      </b-form-group>
      <b-form-group>
        <label>Gün Sayısı</label>
        <b-form-input v-model="permit.daycount" type="number"/>
      </b-form-group>
      <template v-slot:modal-footer>
        <b-button variant="secondary" @click="$refs.permitModal.hide()">Kapat</b-button>
        <b-button variant="primary" @click="payPermit">İzin Ver</b-button>
      </template>
    </b-modal>

    <b-modal ref="employeeHistory" title="Avans Geçmişi">
      <b-table
          ref="table"
          class="align-items-center"
          thead-class="thead-light"
          :fields="[
            { key: 'title', label: 'Başlık' },
            { key: 'price', label: 'Ücret' },
            { key: 'date', label: 'Ödeme Tarihi' },
          ]"
          :items="history"
          show-empty>

        <template v-slot:empty>
          <div class="text-center">
            {{ $t("Henüz hiçbir kayıt girmemişsiniz") }}!
          </div>
        </template>

        <template v-slot:table-busy>
          <div style="width: 100%; text-align:center;">
            <b-spinner label="Spinning"></b-spinner>
          </div>
        </template>

      </b-table>

      <template v-slot:modal-footer>
        <b-button variant="primary" @click="$refs.employeeHistory.hide()">Kapat</b-button>
      </template>
    </b-modal>
    <b-modal ref="employeePermitHistory" :title="activeEmployee.full_name+' İzin Geçmişi'">
      <b-table
          ref="table"
          class="align-items-center"
          thead-class="thead-light"
          :fields="[
            { key: 'start_at', label: 'İzne Çıkış Tarihi' },
            { key: 'daycount', label: 'Gün Sayısı' },
            { key: 'finish_at', label: 'Dönüş Tarihi' },
            {key:'id', label: 'actions'}
          ]"
          :items="permitHistory"
          show-empty>

        <template v-slot:empty>
          <div class="text-center">
            {{ $t("Henüz hiçbir kayıt girmemişsiniz") }}!
          </div>
        </template>

        <template v-slot:cell(id)="data">
          <b-button variant="danger" size="sm" @click="removePermit(data.item.id)">X</b-button>
        </template>
        <template v-slot:table-busy>
          <div style="width: 100%; text-align:center;">
            <b-spinner label="Spinning"></b-spinner>
          </div>
        </template>

      </b-table>

      <template v-slot:modal-footer>
        <b-button variant="primary" @click="$refs.employeePermitHistory.hide()">{{ $t("Kapat") }}</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {mapActions} from 'vuex';
import moment from 'moment';

export default {
  name: 'Employees',
  data() {
    return {
      fields: [
        {key: 'full_name', label: this.$i18n.t('Ad Soyad')},
        {key: 'gsm', label: this.$i18n.t('Telefon')},
        {key: 'email', label: this.$i18n.t('E-mail')},
        {key: 'blood_type', label: this.$i18n.t('Kan Grubu')},
        {key: 'salary', label: this.$i18n.t('Maaş')},
        {key: 'remeaning_payment', label: this.$i18n.t('Kalan Ödeme')},
        {key: 'actions', label: '', tdClass: 'text-right'}
      ],
      advance: {},
      permit: {
        daycount: 1,
        start_at: moment().format('YYYY-MM-DD')
      },
      activeEmployee: {},
      permitHistory: [],
      history: [],
    };
  },
  methods: {
    ...mapActions(['deleteEmployee', 'getEmployees', 'payAdvance', 'getEmployeeAdvanceHistory', 'getEmployeePermit', 'storePermit', 'deletePermit']),
    removePermit(id) {
      this.deletePermit(id).then(res => {

            this.success('İzin Başarıyla Silindi!')
            this.$refs.employeePermitHistory.hide()
            this.$refs.table.refresh()
          }
      )

    },
    openAdvanceHistoryModal(employee) {
      employee.advanceLoading = true;
      this.getEmployeeAdvanceHistory(employee.id).then(response => {
        employee.advanceLoading = false;
        this.history = response.data;
        this.$refs.employeeHistory.show();
      })
    },
    openPermitHistoryModal(employee) {
      this.getEmployeePermit(employee.id).then(response => {
        this.permitHistory = response.data;
        this.activeEmployee = employee
        this.$refs.employeePermitHistory.show();
      })
    },
    payAction() {
      this.payAdvance(this.advance)
          .then(response => {
            this.refreshTable();
            this.$refs.advanceModal.hide();
            this.success(response.data.message);
          }).catch(error => {
        this.error(error.response.data.message);
      });
    },
    openPayAdvanceModal(id, price) {
      this.advance = {
        employee_id: id,
        price: price,
        date: moment().format('YYYY-MM-DD'),
      };
      this.$refs.advanceModal.show();
    },
    openPayPermitModal(employee) {
      this.activeEmployee = employee
      this.$refs.permitModal.show()
    },

    payPermit() {
      this.storePermit({
        'employee_id': this.activeEmployee.id,
        'daycount': this.permit.daycount,
        'start_at': this.permit.start_at
      }).then(res => {
        this.success(res.message)
        this.$refs.permitModal.hide()
      })
    },

    deleteRecord(id) {
      this.$swal({
        icon: 'warning',
        title: 'Dikkat',
        text: 'Kayıt silinecektir, emin misiniz?'
      }).then(ok => {
        if (ok.value) {
          this.deleteEmployee(id)
              .then(res => {
                this.success(res.data.message);
                this.$refs.table.refresh();
              })
              .catch(err => {
                const error = err.message ? err.message : err.response.data;
                this.error(error);
              });
        }
      });
    },
    getItems() {
      return this.getEmployees({
        page: this.currentPage,
      }).then(response => {
        return response.data;
      });
    },
    refreshTable() {
      this.$refs.table.refresh();
    }
  }
};
</script>
